export class BaleInfoReq{
    inwardNumber : any;
    voucherNumber : any;
    agent : any;
    baleNumber : any;
    fromDate?: Date;
    toDate?: Date;
    variant?: any

    constructor(inwardNumber : any,voucherNumber : any,agent : any,baleNumber : any,fromDate?: Date,toDate?: Date,variant?: any){
        this.inwardNumber = inwardNumber
        this.voucherNumber = voucherNumber
        this.agent = agent
        this.baleNumber = baleNumber
        this.fromDate = fromDate
        this.toDate = toDate
        this.variant = variant
    }
}



export class BaleDateReq{
    baleFromDate?:string
    baleToDate?:string
    fromLot?:string
    toLot?:string
    productId?:number
    variantName?:string
}

export class BaleReportReq{
    baleFromDate?:string
    baleToDate?:string
    baleVariantId?:number
    baleNo?:string
    baleQuality?:string
    inwardNo?:string
    inwardVariantId?:number
    inwardQuality?:string
    inwardVendor?:string
}